import NumberFlow from '@number-flow/react';
import { useState, useEffect } from 'react';

const AnimatedNumber = ({ value, delay = 2000, isVisible = false, ...props }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [showNumber, setShowNumber] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShowNumber(true);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [isVisible, delay]);

  // SSR and initial render: show real value for SEO crawlers
  if (!isMounted) {
    return <span>{value || 0}</span>;
  }

  return <NumberFlow value={showNumber ? value || 0 : 0} {...props} />;
};

export default AnimatedNumber;
